import { KeyboardShortcutModel } from '../models/keyboard-shortcut.model';

export const KeyboardShortcutLayout: KeyboardShortcutModel[] = [
  {
    type: 'navigation',
    title: 'bcKeyboardShortcuts.navigation.navigationTitle',
    shortcuts: [
      {
        description: 'bcKeyboardShortcuts.navigation.navigateUp',
        configurable: true,
        keyboardCombination: ['ctrl', 'alt', 'i']
      },
      {
        description: 'bcKeyboardShortcuts.navigation.navigateDown',
        configurable: true,
        keyboardCombination: ['ctrl', 'alt', 'k']
      },
      {
        description: 'bcKeyboardShortcuts.navigation.navigateLeft',
        configurable: true,
        keyboardCombination: ['ctrl', 'alt', 'j']
      },
      {
        description: 'bcKeyboardShortcuts.navigation.navigateRight',
        configurable: true,
        keyboardCombination: ['ctrl', 'alt', 'l']
      },
      {
        description: 'bcKeyboardShortcuts.navigation.selectWidget',
        configurable: false,
        keyboardCombination: ['enter']
      },
      {
        description: 'bcKeyboardShortcuts.navigation.quickAccept',
        configurable: false,
        keyboardCombination: ['shift', 'enter']
      }
    ]
  },
  {
    type: 'workItems',
    title: 'bcKeyboardShortcuts.workWidgets.workWidgetsTitle',
    shortcuts: [
      {
        description: 'bcKeyboardShortcuts.workWidgets.toggleExpandedMode',
        configurable: true,
        keyboardCombination: ['ctrl', 'alt', 'm']
      },
      {
        description: 'bcKeyboardShortcuts.workWidgets.toggleVisitorInfo',
        configurable: true,
        isBoldFeature: true,
        keyboardCombination: ['ctrl', 'alt', 'n']
      }
    ]
  },
  {
    type: 'chatSpecific',
    title: 'bcKeyboardShortcuts.chatSpecific.chatSpecificTitle',
    shortcuts: [
      {
        description: 'bcKeyboardShortcuts.chatSpecific.toggleSmartResponses',
        configurable: false,
        isBoldFeature: true,
        keyboardCombination: ['ctrl', 'space']
      }
    ]
  },
  {
    type: 'help',
    title: 'bcKeyboardShortcuts.help.helpTitle',
    shortcuts: [
      {
        description: 'bcKeyboardShortcuts.help.helpDialog',
        configurable: true,
        keyboardCombination: ['ctrl', 'alt', 'h']
      }
    ]
  }
];
